<template>
  <div class="line">
    <hr class="line__inner">
  </div>
</template>

<style lang="scss" scoped>
.line {
  max-width: 157.2rem;
  width: 100%;
  height: 0.1rem;
  margin: 0 auto;

  &__inner {
    width: 100%;
    height: 0.1rem;
    background-color: $gray-300;
  }
}
</style>
